import { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import LoaderTransparent from "../../ui/LoaderTransparent";
import { CLP_FORMATTER } from "../../../utils/currency";
import { sumCartTotal } from "../../../services/transforms/cartDataTransforms";
import { FALLBACK_IMAGE } from "../../../utils/uiConstants";
import { Image } from "primereact/image";

const TopbarCartPreview = memo(({
  cartItems,
  cartCount,
  isCartLoading,
  isAuthenticated,
  isCartPage,
  previewStatus,
  onRemoveItem,
  onQuantityChange,
}) => {
  const previewTotal = useMemo(
    () => sumCartTotal(cartItems),
    [cartItems]
  );

  if (!isAuthenticated) return null;

  return (
    <div className="landing-cart-hover mr-4">
      <Link to="/carro" className="landing-cart-link landing-cart-link--header text-color-secondary" aria-label="Ir al carro">
        <i className="pi pi-shopping-cart"></i>
        <span className={`landing-cart-count ${isCartLoading ? "is-loading" : ""}`}>
          {isCartLoading ? <i className="pi pi-spin pi-spinner" style={{ fontSize: "0.75rem" }}></i> : cartCount}
        </span>
      </Link>
      {!isCartPage ? (
        <div className="landing-cart-preview surface-overlay border-1 surface-border shadow-4" role="dialog" aria-label="Vista previa del carro">
          {previewStatus !== "idle" && (
            <LoaderTransparent
              coverParent
              status={previewStatus}
              size={48}
              strokeWidth={2.5}
              loadingMessage="Actualizando..."
              successMessage="Listo"
              errorMessage="Error"
              loadingIcon="pi pi-shopping-cart"
            />
          )}
          {!cartItems.length ? (
            <div className="landing-cart-preview-empty">Tu carro está vacío.</div>
          ) : (
            <>
              <div className="landing-cart-preview-list">
                {cartItems.map((item) => (
                  <article key={item.lineKey || `${item.code}-${item.warehouse || "SIN_ALMACEN"}`} className="landing-cart-preview-item">
                    <Image src={item.image || FALLBACK_IMAGE} alt={item.name} />
                    <div className="landing-cart-preview-info">
                      <strong>{item.name}</strong>
                      <span>SKU: {item.code}</span>
                      <div className="landing-cart-preview-qty">
                        <Button
                          icon="pi pi-minus"
                          className="p-button-text p-button-rounded p-button-sm"
                          onClick={() => onQuantityChange(item, -1)}
                          disabled={previewStatus !== "idle"}
                          aria-label="Reducir cantidad"
                        />
                        <span className="landing-cart-preview-qty-value">{Number(item.quantity || 0)}</span>
                        <Button
                          icon="pi pi-plus"
                          className="p-button-text p-button-rounded p-button-sm"
                          onClick={() => onQuantityChange(item, 1)}
                          disabled={previewStatus !== "idle"}
                          aria-label="Aumentar cantidad"
                        />
                      </div>
                    </div>
                    <div className="landing-cart-preview-right">
                      <span>{CLP_FORMATTER.format(Number(item.price || 0) * Number(item.quantity || 0))}</span>
                      <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-rounded p-button-sm p-button-danger"
                        onClick={() => onRemoveItem(item)}
                        disabled={previewStatus !== "idle"}
                        aria-label="Eliminar producto"
                      />
                    </div>
                  </article>
                ))}
              </div>
              <div className="landing-cart-preview-total">
                <span>Total:</span>
                <strong>{CLP_FORMATTER.format(previewTotal)}</strong>
              </div>
              <div className="landing-cart-preview-actions">
                <Link to="/catalogo">
                  <Button
                    icon="pi pi-plus"
                    label="Seguir comprando"
                    rounded
                    outlined
                    disabled={previewStatus !== "idle"}
                  />
                </Link>
                <Link to="/carro">
                  <Button
                    icon="pi pi-shopping-cart"
                    label="Ir al carro"
                    rounded
                    disabled={previewStatus !== "idle"}
                  />
                </Link>
              </div>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
});

export default TopbarCartPreview;
